import React from 'react'
import { Container, FormGroupCustom, FormLabelCustom, InputDateFinal, InputDateInicial } from './style'
import { Form } from 'react-bootstrap'
import MultiSelect from '../../../../Components/MultiSelect'
import MultiSelectCustom from './multiSelectCustom'

const FiltersServices = ({ 
  setFilters, 
  filters, 
  dataAtendentes, 
  isCurrentStatusChecked, 
  setIsCurrentStatusChecked 
}: any) => {

  const booleanOptionsStatus = [
    { value: 'selectAll', label: 'Selecionar Todos' },
    { value: 'Solicitado', label: 'Solicitado' },
    { value: 'Cancelado pelo atendente', label: 'Cancelado pelo Atendente' },
    { value: 'Cancelado pelo usuário', label: 'Cancelado pelo Usuário' },
    { value: 'Em Andamento', label: 'Em Andamento' },
    { value: 'Finalizado', label: 'Finalizado' },
    { value: 'Cancelado', label: 'Cancelado' },
    { value: 'Restituído', label: 'Restituído' },
    { value: 'Encaminhado', label: 'Encaminhado' },
  ];

  const handleChangeDataInicial = (
    e: React.ChangeEvent<HTMLInputElement>
  ): void => {
    let value = e.target.value;
    setFilters({
      ...filters,
      data: value
    })
  }

  const optionsAtendente = dataAtendentes?.atendentes?.map(atendente => ({
    value: atendente.cpf,
    label: atendente.name,
  }));

  const handleChange = (selectedOptions) => {
    if (isCurrentStatusChecked) {
      setFilters({ ...filters, status_atual: selectedOptions });
    } else {
      setFilters({ ...filters, status: selectedOptions });
    }
  };


  const toggleCurrentStatusChecked = () => {
    setIsCurrentStatusChecked(!isCurrentStatusChecked);
    if (!isCurrentStatusChecked) {
      setFilters({ ...filters, status: [], status_atual: filters.status_atual });
    } else {
      setFilters({ ...filters, status_atual: [], status: filters.status });
    }
  }


  const handleChangeAtendente = (selectedOptions) => {
    setFilters({
      ...filters,
      atendente: selectedOptions || [],
    });
  };

  return (
    <Container className='mt-3'>
      <FormGroupCustom className="mb-3">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <FormLabelCustom htmlFor="statusAtualCheckbox">Status</FormLabelCustom>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Form.Check
              id="statusAtualCheckbox"
              type="checkbox"
              label="Status Atual"
              checked={isCurrentStatusChecked}
              onChange={toggleCurrentStatusChecked}
              style={{ marginRight: '10px' }}
            />
          </div>
        </div>
        <MultiSelectCustom
          options={booleanOptionsStatus}
          value={filters?.status && filters.status.length > 0 ? filters.status : filters.status_atual}
          onChange={handleChange}
          placeholder="Selecione um ou mais status."
        />
      </FormGroupCustom>
      <FormGroupCustom>
        <FormLabelCustom>
          Protocolo
        </FormLabelCustom>
        <Form.Control
          type="Protocolo"
          required
          value={filters.protocol}
          onChange={(event) => setFilters({ ...filters, protocol: event.target.value })}
        />
      </FormGroupCustom>

      <FormGroupCustom className="mb-3" controlId="formBasicEmail">
        <FormLabelCustom>Atendente</FormLabelCustom>
        <MultiSelect
          options={optionsAtendente}
          value={filters?.atendente}
          onChange={handleChangeAtendente}
          placeholder="Selecione um ou mais atendentes."
        />
      </FormGroupCustom>

      <FormGroupCustom className="mb-3" controlId="formBasicEmail">
        <FormLabelCustom>Data início</FormLabelCustom>
        <InputDateInicial
          style={{ width: "auto" }}
          type={"date"}
          placeholder="Data inicial"
          value={filters.dataInicio}
          disabled={false}
          onChange={(event) => setFilters({ ...filters, dataInicio: event.target.value })}
        />
      </FormGroupCustom>
      <FormGroupCustom className="mb-3" controlId="formBasicEmail">
        <FormLabelCustom>Data Fim</FormLabelCustom>
        <InputDateFinal
          style={{ width: "auto" }}
          type={"date"}
          placeholder="Data final"
          value={filters.dataFim}
          disabled={false}
          onChange={(event) => setFilters({ ...filters, dataFim: event.target.value })}
        />
      </FormGroupCustom>

      <FormGroupCustom className="mb-3" controlId="formBasicEmail">
        <FormLabelCustom>Data de atendimento</FormLabelCustom>
        <InputDateInicial
          type={"date"}
          placeholder="Data de criação"
          value={filters.data}
          disabled={false}
          onChange={handleChangeDataInicial}
        />
      </FormGroupCustom>
    </Container>
  )
}

export default FiltersServices